import { useNavigate, useSearch } from "@tanstack/react-router";
import { ThreadSort } from "@/gql/graphql";

export function useThreadSort() {
  const navigate = useNavigate();
  const { threadSort } = useSearch({ strict: false }) as {
    threadSort?: ThreadSort;
  };

  return {
    sort: threadSort ?? ThreadSort.LatestMessage,
    onSortChange: (sort: ThreadSort) =>
      navigate({
        to: ".",
        // The default stays out of the URL so a plain link opens the list the
        // way it always has.
        search: (prev: Record<string, unknown>) => ({
          ...prev,
          threadSort: sort === ThreadSort.LatestMessage ? undefined : sort,
        }),
        replace: true,
      }),
  };
}
